import { render, staticRenderFns } from "./newDataQueries.vue?vue&type=template&id=866d7774&scoped=true&"
import script from "./newDataQueries.vue?vue&type=script&lang=js&"
export * from "./newDataQueries.vue?vue&type=script&lang=js&"
import style0 from "./newDataQueries.vue?vue&type=style&index=0&id=866d7774&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866d7774",
  null
  
)

export default component.exports